/* TODO: Stubbed out button, ShareButton component button to be implemented */
import React, { useState, useRef } from 'react';
import clsx from 'clsx';

import { IconTypes } from 'components/helpers/SvgIcon';
import { BaseActionButtonProps } from '../BaseActionButtonProps';

import commonStyles from '../ActionButtonCommon.module.scss';
import styles from './ShareButton.module.scss';
import { ActionItem, useActionRenderer } from '../..';
import { ActionDialog } from '../../ActionDialog/ActionDialog';
import CtaButton from 'components/helpers/Atoms/Cta/CtaButton';
import useDictionary from 'lib/hooks/useDictionary';
export interface ShareOption {
  id: string;
  label: string;
  icon: IconTypes;
}
export interface ShareButtonProps extends BaseActionButtonProps {
  disabled?: boolean;
  dialogPosition?: 'right' | 'bottom';
  subActions?: ActionItem[];
}

export const ShareButton = ({
  label,
  variant,
  disabled,
  dialogPosition = 'right',
  subActions,
  toolbarIdentifier,
  eventPositionSuffix,
}: ShareButtonProps): JSX.Element => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { getDictionaryValue } = useDictionary();

  const { renderActionList } = useActionRenderer({
    variant,
    toolbarIdentifier: toolbarIdentifier,
  });

  const getGtmPosition = (): string => {
    return [toolbarIdentifier, eventPositionSuffix].filter(Boolean).join('.') || '';
  };

  const gtmEvent = {
    event: 'share_menu_click',
    position: getGtmPosition(),
  };

  const handleClick = () => {
    setIsDialogOpen((prev) => !prev);
  };

  const handleCloseDialog = () => {
    if (buttonRef.current) buttonRef.current.focus();
    setIsDialogOpen(false);
  };

  return (
    <div
      className={clsx(styles.shareButtonContainer, {
        [commonStyles['actionButtonWrapper--horizontal']]: variant === 'horizontal',
      })}
    >
      <CtaButton
        ref={buttonRef}
        ctaStyle={variant === 'horizontal' ? 'link-invert-underline' : 'none'}
        ctaVariant="brand"
        onClick={handleClick}
        disabled={disabled}
        aria-label={label}
        className={clsx(
          commonStyles.actionButtonBase,
          commonStyles[`actionButton--${variant}`],
          styles.shareButton,
          styles[variant]
        )}
        ctaIconClassName={clsx(commonStyles.icon, styles.shareIcon)}
        aria-haspopup="menu"
        aria-expanded={!!isDialogOpen}
        aria-controls={'share-dialog'}
        gtmEvent={gtmEvent}
        ctaIconBefore="share"
        ctaIconBeforeViewBox="0 0 17 19"
        ctaIconSize="sm"
        ctaIconNoSpacer={variant === 'vertical'}
        text={label}
      />

      {isDialogOpen && (
        <ActionDialog
          isOpen={isDialogOpen}
          onClose={handleCloseDialog}
          buttonRef={buttonRef}
          position={dialogPosition}
          id={'share-dialog'}
        >
          <h2 id="shareDialogTitle" className="screenReaderText">
            {getDictionaryValue('Components.ActionToolBar.ShareOptions') || 'Share options'}
          </h2>
          <ul className={styles.dialogOptions}>
            {renderActionList(subActions ?? [], subActions?.length, styles.dialogOption, true)}
          </ul>
        </ActionDialog>
      )}
    </div>
  );
};
